module.exports = __webpack_public_path__ + "media/images/admin/icons/download-cloud-2817d948d07a18805ceb6c7f234ab533.svg";